/*jshint esversion: 6 */
import Vue from 'vue';
import axios from 'axios';
// import {extractErrorDetails} from '@/helpers/util.js';

import router from '@/router/index';


const initialState = () => ({
  wallet_settings: {
    sorting: false,
    trains: [],
    taktareas: [],
    colors: [],
    status: [],
    icons: [],
    filter: false,
    steps: [],
  },
  wallet_settings_cache: {},
  update_key_stepcard: 0,
});

// State object
const state = initialState();
// Getter functions
const getters = {
  //local variables
  getWalletSettings: (state) => {
    return state.wallet_settings;
  },
  getUpdateKeyStepCard: (state) => state.update_key_stepcard,
  //Getters to UltraStore state
  getWorkCard: (state, getters, rootState) => (payload) => {
    return rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].work_cards.find(card => card.id === payload.id);
  },
  getQualityCard: (state, getters, rootState) => (payload) => {
    return rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].quality_cards.find(card => card.id === payload.id);
  },
  getDefectCard: (state, getters, rootState) => (payload) => {
    return rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].defect_cards.find(card => card.id === payload.id);
  },
  getHandoverCard: (state, getters, rootState) => (payload) => {
    return rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].handover_cards.find(card => card.id === payload.id);
  },
  getLogisticCard: (state, getters, rootState) => (payload) => {
    return rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].logistic_cards.find(card => card.id === payload.id);
  },
  getDesignCard: (state, getters, rootState) => (payload) => {
    return rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index].design_cards.find(card => card.id === payload.id);
  },
  getStepCards: (state, getters, rootState) => (payload) => {
    let filter = {
      setting: state.wallet_settings.sorting,
    };
    if (filter.setting === 'trains') {
      filter.prop = 'train_id';
      filter.value = payload.section;
    } else if (filter.setting === 'taktareas') {
      filter.prop = 'taktarea_id';
      filter.value = payload.section;
    } else if (filter.setting === 'colors') {
      filter.prop = 'work_package_color';
      filter.value = payload.section.value;
    } else if (filter.setting === 'icons') {
      filter.prop = 'work_package_icon';
      filter.value = payload.section.value;
    } else if (filter.setting === 'status') {
      filter.prop = 'done';
      if (payload.section.value === 'done') {
        filter.value = true;
      } else if (payload.section.value === 'none') {
        filter.value = false;
      } else {
        filter.value = 'none';
      }
    } 
    // microlevel
    // if (rootState.View.isMicroView) {
    //   filter.prop = 'taktarea_id';
    //   filter.value = payload.section;
    // }
    let step_cards = rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index];
    let work_cards = step_cards.work_cards.filter(card => card[filter.prop] === filter.value && !rootState.View.wallet_show_workpackages && (!state.wallet_settings.filter || state.wallet_settings.steps.includes('work')));
    let quality_cards = step_cards.quality_cards.filter(card => card[filter.prop] === filter.value && (card.offset !== 0 || !rootState.View.wallet_show_workpackages) && (!state.wallet_settings.filter || state.wallet_settings.steps.includes('quality')));
    let defect_cards = step_cards.defect_cards.filter(card => card[filter.prop] === filter.value && (card.offset !== 0 || !rootState.View.wallet_show_workpackages) && (!state.wallet_settings.filter || state.wallet_settings.steps.includes('defect')));
    let handover_cards = step_cards.handover_cards.filter(card => card[filter.prop] === filter.value && (card.offset !== 0 || !rootState.View.wallet_show_workpackages) && (!state.wallet_settings.filter || state.wallet_settings.steps.includes('handover')));
    let logistic_cards = step_cards.logistic_cards.filter(card => card[filter.prop] === filter.value && (card.offset !== 0 || !rootState.View.wallet_show_workpackages) && (!state.wallet_settings.filter || state.wallet_settings.steps.includes('logistic')));
    let design_cards = step_cards.design_cards.filter(card => card[filter.prop] === filter.value && (card.offset !== 0 || !rootState.View.wallet_show_workpackages) && (!state.wallet_settings.filter || state.wallet_settings.steps.includes('design')));
    let filtered_step_cards = {
      work_cards: work_cards,
      quality_cards: quality_cards,
      defect_cards: defect_cards,
      handover_cards: handover_cards,
      logistic_cards: logistic_cards,
      design_cards: design_cards,
    };
    let global_index = 0;
    ['work', 'quality', 'defect', 'handover', 'logistic', 'design'].forEach(step_type => {
      filtered_step_cards[`${step_type}_cards`].forEach(step_card => {
        step_card.global_index = global_index;
        global_index++;
      });
    });
    filtered_step_cards.count = work_cards.length + quality_cards.length + defect_cards.length + handover_cards.length + logistic_cards.length + design_cards.length;
    return filtered_step_cards;
  },
};
// Actions
const actions = {
  // with Ultra store mutation
  requestProjectStepCards({commit, rootGetters, rootState}, payload) {
    return new Promise((resolve, reject) => {

      let headers = {
        'Content-Type': 'application/json',
        'cache-control': 'no-cache',
      };
      
      if (rootGetters['Auth/isCloudPrint']) {
        headers.TAKTCloudprintToken = rootState.Auth.cloudprint_token;
      }

      axios({
          url: 'projects/' + payload.project_id + '/stepcards?index=' + payload.takt_index,
          method: 'GET',
          headers: headers
        })
        .then(resp => {
          let ultra_payload = {
            url: [
              {projects: payload.project_id}
            ],
            update: {
              step_cards: Object.assign(rootState.Ultra.projects[payload.project_id].step_cards, {[payload.takt_index]: resp.data.data})
            }
          };
          commit('Ultra/update_u_object', {rootState, payload: ultra_payload}, {root: true});
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  //with local mutation mutating ultra store state
  updateStepCardStatusOld({commit, rootState}, payload) {
    return new Promise((resolve) => {
    let takt_index = parseInt(router.currentRoute.params.takt_index);
    if (router.currentRoute.params.selected_column === 'right' || payload.wallet_column === 'right') {
      takt_index = takt_index + 1;
    } else if (router.currentRoute.params.selected_column === 'left' || payload.wallet_column === 'left') {
      takt_index = takt_index - 1;
    }
    if (!payload.wallet_column) {
      payload.takt_index = takt_index + parseInt(payload.offset);
    } else {
      payload.takt_index = takt_index;
    }
    commit('update_step_card_status', {rootState, payload});
    resolve();
  });
  },
  updateStepCardStatus({commit, rootState}, payload) {
    return new Promise((resolve) => {
    let takt_index = parseInt(router.currentRoute.params.takt_index);
    if (router.currentRoute.params.selected_column === 'right' || payload.wallet_column === 'right') {
      takt_index = takt_index + 1;
    } else if (router.currentRoute.params.selected_column === 'left' || payload.wallet_column === 'left') {
      takt_index = takt_index - 1;
    }
    if (payload.offset) {
      takt_index = takt_index + parseInt(payload.offset);
    }
    payload.takt_index = takt_index;
    commit('update_step_card_status', {rootState, payload});
    resolve();
  });
  },
  //local variables
  increaseUpdateKeyStepCard({commit}) {
    commit('increase_update_key_stepcard');
  },
  setWalletSettings({commit, getters, rootState, rootGetters}, payload) {
    return new Promise((resolve) => {
    if (payload.setting === 'sorting' &&
        state.wallet_settings[payload.value].length === 0) {
        if (payload.value === 'colors') {
          commit('set_wallet_settings', {
            setting: 'colors',
            value: rootGetters['TWorkPackage/getTWorkpackageColors'][0]
          });
        } else if (payload.value === 'status') {
          commit('set_wallet_settings', {
            setting: 'status',
            value: rootState.Ultra.status_array[0]
          });
        } else if (payload.value === 'trains') {
          commit('set_wallet_settings', {
            setting: 'trains',
            value: getters.getStatisticsTrainSelector[0]
          });
        }
      }
    commit('set_wallet_settings', payload);
    resolve();
  });
  },
  resetWalletSettings({commit}, payload) {
    return new Promise((resolve) => {
    commit('reset_wallet_settings', payload);
    resolve();
  });
  },
  resetWalletStepFilter({commit}) {
    return new Promise((resolve) => {
    commit('reset_wallet_step_filter');
    resolve();
  });
  },
  setWalletSettingsCache({commit}) {
    commit('set_wallet_setting_caches');
  },
  resetWalletSettingsCache({commit}) {
    commit('reset_wallet_setting_caches');
  }
};
// Mutations
const mutations = {
  set_wallet_settings(state, payload) {
    if (payload.setting === 'sorting') {
      if (state.wallet_settings.sorting === payload.value) {
        state.wallet_settings.sorting = false;
      } else {
        state.wallet_settings.sorting = payload.value;
      }
  } else if (payload.setting === 'filter') {
    state.wallet_settings.filter = payload.value
  } else if (payload.setting === 'steps') {
    let index = state.wallet_settings.steps.indexOf(payload.value)
    if (index !== -1) {
       state.wallet_settings.steps.splice(index,1)
    } else {
      state.wallet_settings.steps.push(payload.value)
    }
  }
  else {
    if (payload.setting === state.wallet_settings.sorting &&
        state.wallet_settings[payload.setting][0] === payload.value) {
          // state.wallet_settings[payload.setting].splice(0, 1);
          // state.wallet_settings.sorting = false;
    } else {
      state.wallet_settings[payload.setting].splice(0, 1, payload.value);
      state.wallet_settings.sorting = payload.setting;
    }
  }
  },
  reset_wallet_settings(state, payload) {
      state.wallet_settings[payload.setting].splice(0, 1, payload.value);
      state.wallet_settings.colors = [];
      state.wallet_settings.status = [];
      state.wallet_settings.sorting = payload.setting;
  },
  reset_wallet_step_filter(state) {
      state.wallet_settings.steps = [];
      state.wallet_settings.filter = false;
  },
  update_step_card_status(state, {rootState, payload}) {
    Vue.set(rootState.Ultra.projects[payload.project_id].step_cards[payload.takt_index][`${payload.step_type}_cards`].find(card => card.id === payload.step_id), 'done', payload.done);
  },
  increase_update_key_stepcard(state) {
    state.update_key_stepcard++;
  },
  set_wallet_setting_caches(state) {
    state.wallet_settings_cache = JSON.parse(JSON.stringify(state.wallet_settings))
  },
  reset_wallet_setting_caches(state) {
    state.wallet_settings = JSON.parse(JSON.stringify(state.wallet_settings_cache))
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
